import { UpsellProductRulesDto } from "@intelligems/ig-types";

export interface IUpsellProductRulesState {
  isSuccess: boolean;
  upsellProductRules: UpsellProductRulesDto[];
  storedUpsellProductRules: UpsellProductRulesDto[];
}

export const initialIUpsellProductRulesState: IUpsellProductRulesState = {
  isSuccess: false,
  upsellProductRules: [],
  storedUpsellProductRules: [],
};
